module.exports = __webpack_public_path__ + "img/banner.1a3d62d3.jpg";